import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "IEC-60320-C13",
  "use": "IEC-60320-C13-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"IEC-60320-C13\"><path d=\"M10 6h20c4.725 2.344 8.058 5.677 10 10v12c-.542 2.437-1.875 4.437-4 6H4c-2.125-1.563-3.458-3.563-4-6V16c1.942-4.323 5.275-7.656 10-10zm8 5v9h4v-9h-4zm12 8v9h4v-9h-4zM7 19v9h3v-9H7z\" fill=\"#000\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol